import styled, { css } from 'styled-components';

export const AnimatedHamburger: React.FC<{
  onClick?: () => void;
  isOpen?: boolean;
}> = ({ onClick, isOpen }) => {
  return (
    <Container onClick={onClick}>
      <SvgIcon className={isOpen ? 'cross' : ''} viewBox='0 0 800 600'>
        <path
          id='top'
          d='M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200'
        />
        <path id='middle' d='M300,320 L540,320' />
        <path
          id='bottom'
          d='M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190'
          transform='translate(480, 320) scale(1, -1) translate(-480, -318)'
        />
      </SvgIcon>
    </Container>
  );
};

const Container = styled.div`
  width: 75px;
  height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
`;

const strokeTransition = css`
  transition: stroke-dashoffset 0.5s cubic-bezier(0.25, -0.25, 0.75, 1.25),
    stroke-dasharray 0.5s cubic-bezier(0.25, -0.25, 0.75, 1.25);
`;

const SvgIcon = styled.svg`
  width: 100%;
  height: 100%;

  path {
    fill: none;
    stroke: #283288;
    stroke-width: 30;
    stroke-linecap: round;
    ${strokeTransition}
  }

  #top,
  #bottom {
    stroke-dasharray: 240px 950px;
    stroke-dashoffset: 0;
  }
  #middle {
    stroke-dasharray: 240px 240px;
    stroke-dashoffset: 0;
  }

  &.cross {
    #top,
    #bottom {
      stroke-dashoffset: -650px;
    }
    #middle {
      stroke-dashoffset: -115px;
      stroke-dasharray: 1px 220px;
    }
  }
`;
